import { useState, useEffect } from 'react';

const useVbData = () => {
  const [toGeneratePeopleIds, setToGeneratePeopleIds] = useState(
    JSON.parse(localStorage.getItem('toGeneratePeopleIds') ?? '[]'),
  );

  useEffect(() => {
    const handler = () =>
      setToGeneratePeopleIds(
        JSON.parse(localStorage.getItem('toGeneratePeopleIds') ?? '[]'),
      );

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const updateToGeneratePeopleIds = (data: string[]) => {
    localStorage.setItem('toGeneratePeopleIds', JSON.stringify(data));
    window.dispatchEvent(new Event('storage'));
  };

  return { toGeneratePeopleIds, updateToGeneratePeopleIds };
};

export default useVbData;
